declare var pglob : IPhotometerGlobalVar;


module product_references {
  'use strict';

	/**
	 * The main controller for the app. The controller:
	 */
  export class ProductReferenceCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      'productReferenceService', 
      'pageMetaService',
      '$filter', 
      'anchorNavService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IProductReferencesCtrlScope,
      private productReferenceService: ProductReferenceService,
      private pageMetaService: navigation.IPageMetaService,
      private $filter: IProductReferenceFilter,
      private anchorNavService : navigation.IAnchorNavService
      ) {

      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      
      $scope.meta = pageMetaService.getPageMeta;

      $scope.limit = 5;
            
      this.productReferenceService.getReferences(pglob.RouteData.RouteEntry).then((response : { data : ProductReferenceData}) => { 
        this.$scope.data = response.data;
        if (response.data.showProductFilter) this.$scope.showProductFilter = response.data.showProductFilter;
      });

      anchorNavService.subscribeOnLocationChanged($scope, (event :ng.IAngularEvent, re:IRouteEntry) => {
        this.productReferenceService.getReferences(re).then((response : { data : ProductReferenceData}) => { 
          this.$scope.data = response.data;
          if (response.data.showProductFilter) this.$scope.showProductFilter = response.data.showProductFilter;
        }); 
      });

      $scope.$watch('showProductFilter', (newVal, oldVal) => {
        if ($scope.showProductFilter && !$scope.productsLoaded) {
          this.productReferenceService.getProducts().then((response) => {
            this.$scope.allProducts = response.data;
            this.$scope.productsLoaded = true;
          })
        }
      });

    }

    public getCount() : number {
      if (!this.$scope.data || !this.$scope.data.References) return undefined;
      return this.$filter('productReferenceFilter')(this.$scope.data.References, this.$scope.filter).length; 
    }

    public nextPage() {
      if (!this.$scope.data || !this.$scope.data.References) return;
      this.$scope.limit = Math.min(this.$scope.limit + 10, this.$filter('productReferenceFilter')(this.$scope.data.References, this.$scope.filter).length);
    }

    
    public isDownloadVisible() {
      if (!this.$scope.data || !this.$scope.data.References) return false;
      if (this.$scope.filter && (this.$scope.filter.Country || this.$scope.filter.Industry || this.$scope.filter.inUseSince || this.$scope.filter.MeasuringTask)) return true;
      return this.$scope.limit > 5;
    }

         


  }

}

